import React from "react";
import * as SC from "./PostEditorSnapchat.styled";

import logger from "../../../../../utils/LoggerFrontend.js";
import ChannelDataEditor from "../../Campaign__Create_ChannelDataEditor.jsx";
import { ExpandUpIcon } from "../../Svg/index.js";
import { channelsByShortName } from "../../../../../data/app__channels.js";
import CampaignCreatePerformanceEditor from "../../campaign-create-performance-editor/CampaignCreatePerformanceEditor.jsx";
import useMediaAssets from "../hooks/useMediaAssets.js";
import TemplatePostPreview from "../../TemplatePost/TemplatePost__Preview/TemplatePostPreview.jsx";
import { useTranslation } from "react-i18next";

const PostEditorSnapchat = ({
  orgaId,
  postData,
  channelData,
  updatePost,
  updateChannelData,
  editable,
  channel,
  selectedCreativeIndexToEdit,
  setSelectedCreativeIndexToEdit,
  campaignLanguage
}) => {
  logger.debug("PostEditorSnapchat:render", "render:", {
    postData,
    channelData,
    updatePost,
    editable
  });

  const mediaAssets = useMediaAssets(postData);
  const { t } = useTranslation();

  const templatePreviewSizes = {
    minHeight: SC.SNAPCHAT_IMAGE_SIZE_SPEC.minHeight,
    maxHeight: SC.SNAPCHAT_IMAGE_SIZE_SPEC.maxHeight,
    width: SC.SNAPCHAT_IMAGE_SIZE_SPEC.pictureWidth,
    minAspect: channelsByShortName.snapchat.minAspect,
    maxAspect: channelsByShortName.snapchat.maxAspect
  };

  return (
    <SC.PostEditorSnapchatWrapper>
      <SC.SnapchatWrapper>
        <SC.HeaderWrapper>
          <ChannelDataEditor
            updateChannelData={updateChannelData}
            value={channelData.companyName}
            dataKey="companyName"
            textStyle={SC.companyNameStyle}
            limit={channelsByShortName.snapchat.limits.companyName}
            label={t("Company name")}
            tooltip={t("Company name")}
            editable={editable}
            dark
          />
          <ChannelDataEditor
            updateChannelData={updateChannelData}
            value={channelData.title}
            dataKey="title"
            textStyle={SC.titleStyle}
            limit={channelsByShortName.snapchat.limits.title}
            label={t("Job Title")}
            tooltip={t("Job Title")}
            editable={editable}
            dark
          />
        </SC.HeaderWrapper>
        <TemplatePostPreview
          orgaId={orgaId}
          creatives={postData.creatives}
          creativeAssets={postData.creativeAssets}
          selectedMediaAssetIndexToEdit={selectedCreativeIndexToEdit}
          mediaAssets={mediaAssets}
          updatePost={updatePost}
          channel={channel}
          editable={editable}
          templatePreviewSizes={templatePreviewSizes}
        />
        <SC.FooterWrapper>
          <ExpandUpIcon />
          <SC.LearnMoreAnchor target="_blank" href={channelData.url}>
            {t("More", { lng: campaignLanguage })}
          </SC.LearnMoreAnchor>
        </SC.FooterWrapper>
        <SC.AdText>{t("Ad", { lng: campaignLanguage })}</SC.AdText>
      </SC.SnapchatWrapper>
      <CampaignCreatePerformanceEditor
        creatives={postData.creatives}
        editable={editable}
        channel={channel}
        mediaAssets={mediaAssets}
        updatePost={updatePost}
        padding="12px 0 0 0"
        selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
        setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
      />
    </SC.PostEditorSnapchatWrapper>
  );
};

export default PostEditorSnapchat;
